import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
  Form,
  Input,
  Button,  
  Dropdown,
  Checkbox,  
  Label
} from 'semantic-ui-react';
import _ from 'lodash';
import { DateTimeInput, DateInput, TimeInput } from 'semantic-ui-calendar-react-17';

import { userActions } from '../../actions/user.actions';

import moment from 'moment';
import momentDurationFormatSetup from "moment-duration-format";
import 'moment/locale/pt-br';

import PropTypes from 'prop-types';
import { userConstants } from '../../constants/user.constants';
import { requestActions } from '../../actions/request.actions';
import { settingsActions } from '../../actions/settings.actions';
import { requestConstants } from '../../constants/request.constants';

class RequestFormScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      request: {
        title: '',
        description: '',
        startDate: '',
        scheduledDate: '',
        scheduledStartTime: '',
        scheduledEndTime: '',
        typeLabel: '',
        type: null,
        minutesAmount: 0,
        repeats: 0,
        requesterId: [],
        approvers: [],
      },
      search: '',
      errors: {},
      selectedUsers: [],
      showRepeat: false,
      submitted: false,
    };
  }

  componentDidMount() {    
    const { match, dispatch } = this.props;    
    
    this.handleSearchDebounced = _.debounce(function() {
      this.fetchSubordinates();
    }, 500);

    dispatch(settingsActions.fetchGlobal());

    if (match.params.id) {
        dispatch(requestActions.get(match.params.id))
            .then(() => {                
                const request = _.mapKeys(this.props.request, function (v, k) { return k[0].toLowerCase() + k.substring(1); });
                if (request) {
                  if (request.type.toString() === requestConstants.TYPE_SCHEDULED.toString()) {
                    const start = moment(request.startDate);
                    const end = moment(request.startDate).add(request.minutesAmount || 0, "minutes");
                    request.scheduledDate = start.format("DD/MM/YYYY");
                    request.scheduledStartTime = start.format("HH:mm");
                    request.scheduledEndTime = end.format("HH:mm");
                    request.startDate = start.format("DD/MM/YYYY HH:mm");
                  } else {
                    request.startDate = moment(request.startDate).format("DD/MM/YYYY");
                  }
                }
                this.setState({ request });
            });
    }    

    this.fetchSubordinates();
  }

  static get propTypes() { 
    return {       
        me: PropTypes.any,
        subordinates: PropTypes.any,
        usersLoading: PropTypes.bool,
        loading: PropTypes.bool,
        request: PropTypes.any,
        match: PropTypes.any,
        settings: PropTypes.any,
        typeOptions: PropTypes.array,
    }; 
  }

  simpleSearch(options, query) {    
    query = query.toLowerCase();    
    return options.filter(opt => {  
      return opt.description && (opt.text.toLowerCase().indexOf(query) >= 0 || opt.description.toLowerCase().indexOf(query) >= 0);
    });
  }

  handleChange(field, data) {    
    const { request } = this.state;            
    request[field] = data;            
    this.setState({ request });    
  }

  handleUserChange(data) {
    const requesterIds = data.value;
    const selectedUsers = [];
    data.options.map((option) => {
      if (requesterIds.includes(option.value)) {
        selectedUsers.push(option);
      }
    })
   
    this.setState({ selectedUsers });
    this.handleChange("requesterId", data.value)
  }

  handleUserSearchChange(search) {    
    this.setState({ search });
    this.handleSearchDebounced();
  }

  fetchSubordinates() {
    const { dispatch } = this.props;
    const { search } = this.state;
    dispatch(userActions.subordinates({ search, orderBy: "Name" }));
  }

  onDateChange(e) {
    this.handleChange("startDate", e)
  }

  // Limite máximo de minutos por solicitação, respeitando a configuração
  // e nunca ultrapassando 24h.
  getMaxMinutes() {
    const { me, settings } = this.props;
    let maxMinutesRequest = 120;
    if (settings) {
      maxMinutesRequest = settings.MaxMinutesRequest;
      if (settings.AllowOverrideMaxMinutesManager && me && me.Role != userConstants.ROLE_USER) {
        maxMinutesRequest = 24 * 60;
      }
    }
    return Math.min(maxMinutesRequest, 24 * 60);
  }

  // Atualiza um dos campos de horário agendado (data, início ou fim) e recalcula
  // startDate/minutesAmount. Considera virada de dia (ex.: 22:00 -> 03:00).
  handleScheduledChange(field, value) {
    const { request } = this.state;
    request[field] = value;

    const { scheduledDate, scheduledStartTime, scheduledEndTime } = request;
    if (scheduledDate && scheduledStartTime && scheduledEndTime) {
      const start = moment(`${scheduledDate} ${scheduledStartTime}`, "DD/MM/YYYY HH:mm");
      const end = moment(`${scheduledDate} ${scheduledEndTime}`, "DD/MM/YYYY HH:mm");
      if (start.isValid() && end.isValid()) {
        if (end.isSameOrBefore(start)) {
          end.add(1, "day");
        }
        request.startDate = start.format("DD/MM/YYYY HH:mm");
        request.minutesAmount = end.diff(start, "minutes");
      }
    }

    this.setState({ request });
  }

  validate() {
    const { request } = this.state;
    const { me, settings } = this.props;

    let errors = {};
    let valid = true;

    if (!request.title || request.title.length == 0) {
      errors.title = "Preencha o título";
      valid = false;
    }

    if (!request.description || request.description.length == 0) {
      errors.description = "Preencha a descrição";
      valid = false;
    }

    const isScheduled = request.type !== null && request.type !== "" && request.type.toString() === requestConstants.TYPE_SCHEDULED.toString();

    if (!request.startDate && !isScheduled) {
      errors.startDate = "Preencha a data de início";
      valid = false;
    }

    if (request.type === null || request.type === "") {
      errors.type = "Selecione o tipo de solicitação";
      valid = false;
    }

    if (!isScheduled && request.type !== requestConstants.TYPE_FULLDAY && request.type !== requestConstants.TYPE_START && request.type !== requestConstants.TYPE_UNLOCK && !request.minutesAmount) {
      errors.minutesAmount = "Selecione o tempo adicional";
      valid = false;
    }

    if (isScheduled) {
      if (!request.scheduledDate || !request.scheduledStartTime || !request.scheduledEndTime) {
        errors.scheduled = "Preencha a data, o horário de início e o horário fim";
        valid = false;
      } else {
        const maxMinutes = this.getMaxMinutes();
        if (!request.minutesAmount || request.minutesAmount <= 0) {
          errors.scheduled = "O horário fim deve ser diferente do horário de início";
          valid = false;
        } else if (request.minutesAmount > maxMinutes) {
          errors.scheduled = `O tempo máximo por solicitação é ${moment.duration(maxMinutes, "minutes").format("HH:mm", { trim: false })}`;
          valid = false;
        }
      }
    }
    
    if (request.repeats < 0 || request.repeats > settings.MaxRequestsRepeat) {
      errors.maxRepeats = `Repetições deve ser no máximo ${settings.MaxRepeats}`;
      valid = false;
    }

    if (!request.typeLabel && settings.FixedRequestTypes) {
      errors.typeLabel = 'Selecione a categoria da solicitação';
      valid = false;
    }

    if (!request.project && settings.FixedRequestProjects) {
      errors.project = 'Selecione o projeto da solicitação';
      valid = false;
    }

    if (me.Role != userConstants.ROLE_USER && me.Role != userConstants.ROLE_USER_MANAGER) {
      if ((!request.requesterId || !request.requesterId.length) && !request.id) {
        errors.requesterId = "Selecione o usuário";
        valid = false;
      }
    }
    
    this.setState({ errors });
    return valid;
  }

  handleSubmit(approved) {
    if (!this.validate()) {    
      return;
    }

    const { dispatch, me, typeOptions } = this.props;
    const { request } = this.state;
    let payload = Object.assign({}, request);
    delete payload.scheduledDate;
    delete payload.scheduledStartTime;
    delete payload.scheduledEndTime;
    if (approved) {
      payload.approved = true;
    }

    if (!request.id && typeOptions.length === 1) {
      payload.type = typeOptions[0].value;
    } else if (!request.id && typeOptions.length === 0) {
      payload.type = requestConstants.TYPE_SCHEDULED;
    }

    if (payload.type.toString() === requestConstants.TYPE_SCHEDULED.toString()) {
      payload.startDate = moment(payload.startDate, 'DD/MM/YYYY HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
    } else if (payload.type.toString() === requestConstants.TYPE_START.toString()) {
      payload.startDate = moment(payload.startDate, 'DD/MM/YYYY HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
    } else {
      payload.startDate = moment(payload.startDate, 'DD/MM/YYYY').startOf('day').format('YYYY-MM-DD HH:mm:ss');
    }
    
    if (request.id) {
      dispatch(requestActions.update(request.id, payload));
    } else {    
      if (me.Role != userConstants.ROLE_USER && me.Role != userConstants.ROLE_USER_MANAGER) {
        const requesters = request.requesterId;
        requesters.forEach((requesterId) => {                       
          const newPayload = Object.assign({}, payload);
          newPayload.requesterId = requesterId;          
          dispatch(requestActions.create(newPayload));
        })        
      } else {            
        dispatch(requestActions.create(payload));        
      }
    }    
  }

  render() {    
    const { me, subordinates, loading, usersLoading, settings, typeOptions } = this.props;
    const { request, errors, showRepeat, selectedUsers } = this.state;

    let userOptions = [];
    const userIds = [];
    if (me?.Role != userConstants.ROLE_USER && subordinates && subordinates.Results) {      
      userOptions = subordinates.Results.map(item => {
        userIds.push(item.Id);
        return { key: item.Id, value: item.Id, text: item.Name, description: item.Email, username: item.Username }
      });
    }

    selectedUsers.forEach(item => {
      if (!userIds.includes(item.value)) {
        userOptions.push(item);
      }
    })

    const approverOptions = [];
    if (me && me.ImmediateSuperior) {      
      approverOptions.push({ key: me.ImmediateSuperior.Id, value: me.ImmediateSuperior.Id, text: me.ImmediateSuperior.Name });
    }

    if (me && me.MediateSuperior) {
      approverOptions.push({ key: me.MediateSuperior.Id, value: me.MediateSuperior.Id, text: me.MediateSuperior.Name });
    }
    
    if (request.type !== requestConstants.TYPE_SCHEDULED && request.type !== requestConstants.TYPE_UNLOCK && request.type !== requestConstants.TYPE_START && request.startDate) {
      var parts = request.startDate.split(' ');
      if (parts.length > 1) {
        request.startDate = parts[0];
      }
    }

    let titleOptions = [];    
    let typeLabelOptions = [];    
    let projectOptions = [];    
    let maxMinutesRequest = this.getMaxMinutes();
    let maxRepeats = 30;

    if (settings) {
      maxRepeats = settings.MaxRequestsRepeat;

      if (settings.FixedRequestTitles) {
        var titles = settings.RequestTitles.split("\n");
        titles.forEach((title) => {
          titleOptions.push({ key: title, value: title, text: title });
        });
      }      

      if (settings.FixedRequestTypes) {
        var types = settings.RequestTypes.split("\n");
        types.forEach((title) => {
          typeLabelOptions.push({ key: title, value: title, text: title });
        });
      }      

      if (settings.FixedRequestProjects) {
        var types = settings.RequestProjects.split("\n");
        types.forEach((title) => {
          projectOptions.push({ key: title, value: title, text: title });
        });
      }      

      if (!request.id && typeOptions?.length === 1) {
        request.type = typeOptions[0].value;
      } else if (!request.id && typeOptions?.length === 0) {
        request.type = requestConstants.TYPE_SCHEDULED;
      }      
    }

    let timeOptions = [];
    for (var i = 5; i <= maxMinutesRequest; i += 5) {
      timeOptions.push({key: i, value: i, text: moment.duration(i, "minutes").format("HH:mm", { trim: false })});
    }    
    
    return (  
      <Fragment>
      <h1>Solicitação</h1>
      <Form loading={loading} onSubmit={() => this.handleSubmit()}>
        {(!settings || !settings.FixedRequestTitles) && <Form.Input required error={errors.title} label='Título' value={request.title} name='title' type='text' onChange={(e, data) => this.handleChange("title", data.value)} placeholder='Qual o objetivo da solicitação?' />}
        {settings && settings.FixedRequestTitles && <Form.Field required>
          <label>Título</label>
            <Dropdown
              placeholder='Selecione o título'
              fluid
              label='Título'
              selection              
              onChange={(e, data) => this.handleChange("title", data.value)}
              options={titleOptions}
            />
        </Form.Field>}
        { errors.title && <Label color='red'>{errors.title}</Label>}
        
        <Form.TextArea required error={errors.description} label='Descrição' value={request.description} name='description' onChange={(e, data) => this.handleChange("description", data.value)} type='textarea' placeholder='Descreva o motivo da solicitação' />
        { errors.description && <Label color='red'>{errors.description}</Label>}

        {settings && settings.FixedRequestTypes && <Form.Field required>
          <label>Categoria da Solicitação</label>
            <Dropdown
              placeholder='Selecione o tipo'
              fluid
              label='Tipo'
              selection              
              onChange={(e, data) => this.handleChange("typeLabel", data.value)}
              options={typeLabelOptions}
            />
        </Form.Field>}
        { errors.typeLabel && <Label color='red'>{errors.typeLabel}</Label>}

        {settings && settings.FixedRequestProjects && <Form.Field required>
          <label>Projeto</label>
            <Dropdown
              placeholder='Selecione o projeto'
              fluid
              label='Projeto'
              selection              
              onChange={(e, data) => this.handleChange("project", data.value)}
              options={projectOptions}
            />
        </Form.Field>}
        { errors.project && <Label color='red'>{errors.project}</Label>}

        {typeOptions && typeOptions.length > 1 && <Form.Field required>
            <label>Tipo de Solicitação</label>
            <Dropdown
              placeholder='Selecione'
              fluid              
              selection
              onChange={(e, data) => this.handleChange("type", data.value)}
              options={typeOptions}
              value={request.type}
            />
            { errors.type && <Label basic pointing  color='red'>{errors.type}</Label>}
          </Form.Field>}
        
          {request.type == requestConstants.TYPE_START && <Form.Field required>
            <label>Data de Início</label>
            <DateTimeInput
              localization="pt-br"
              name="startDate"
              closable
              clearable
              placeholder="Data e hora de início da jornada"
              value={request.startDate}
              minDate={new Date()}
              dateTimeFormat="DD/MM/YYYY HH:mm"
              iconPosition="left"
              onChange={(e, data) => this.handleChange("startDate", data.value)}
            />
            { errors.startDate && <Label basic pointing color='red'>{errors.startDate}</Label>}
          </Form.Field>}

        {request.type == requestConstants.TYPE_SCHEDULED && <Fragment>
          <Form.Group widths='equal'>
            <Form.Field required>
              <label>Data</label>
              <DateInput
                localization="pt-br"
                name="scheduledDate"
                closable
                clearable
                placeholder="Data"
                value={request.scheduledDate}
                minDate={new Date()}
                dateFormat="DD/MM/YYYY"
                iconPosition="left"
                onChange={(e, data) => this.handleScheduledChange("scheduledDate", data.value)}
              />
            </Form.Field>

            <Form.Field required>
              <label>Horário de Início</label>
              <TimeInput
                localization="pt-br"
                name="scheduledStartTime"
                closable
                clearable
                placeholder="Início"
                value={request.scheduledStartTime}
                timeFormat="24"
                iconPosition="left"
                onChange={(e, data) => this.handleScheduledChange("scheduledStartTime", data.value)}
              />
            </Form.Field>

            <Form.Field required>
              <label>Horário Fim</label>
              <TimeInput
                localization="pt-br"
                name="scheduledEndTime"
                closable
                clearable
                placeholder="Fim"
                value={request.scheduledEndTime}
                timeFormat="24"
                iconPosition="left"
                onChange={(e, data) => this.handleScheduledChange("scheduledEndTime", data.value)}
              />
            </Form.Field>
          </Form.Group>

          {request.scheduledDate && request.scheduledStartTime && request.scheduledEndTime && request.minutesAmount > 0 &&
            <p style={{ color: '#767676', marginTop: '-0.5em' }}>
              Duração total: {moment.duration(request.minutesAmount, "minutes").format("H[h] mm[min]", { trim: false })}
              {request.scheduledEndTime <= request.scheduledStartTime && ' (termina no dia seguinte)'}
            </p>}

          { errors.scheduled && <Label basic pointing color='red'>{errors.scheduled}</Label>}
        </Fragment>}

        {request.type == requestConstants.TYPE_ADDITIONAL && <Form.Group>
          <Form.Field required>
            <label>Data</label>
            <DateInput
              localization="pt-br"
              name="startDate"
              closable
              clearable
              placeholder="Data"
              value={request.startDate}
              minDate={new Date()}
              dateFormat="DD/MM/YYYY"
              iconPosition="left"
              onChange={(e, data) => this.handleChange("startDate", data.value)}
            />
            { errors.startDate && <Label basic pointing color='red'>{errors.startDate}</Label>}
          </Form.Field>        

          <Form.Field required>
            <label>Tempo Adicional</label>
            <Dropdown
              placeholder='Selecione'
              fluid
              label='Tempo Adicional'
              selection
              value={request.minutesAmount} 
              onChange={(e, data) => this.handleChange("minutesAmount", data.value)}
              options={timeOptions}
            />
            { errors.minutesAmount && <Label basic pointing color='red'>{errors.minutesAmount}</Label>}
          </Form.Field>    
        </Form.Group>}

        {(request.type == requestConstants.TYPE_FULLDAY || request.type == requestConstants.TYPE_UNLOCK) && <Form.Field>
          <label>Data</label>
            <DateInput
              localization="pt-br"
              name="startDate"
              closable
              clearable
              placeholder="Data"
              value={request.startDate}
              minDate={new Date()}
              dateFormat="DD/MM/YYYY"
              iconPosition="left"
              onChange={(e, data) => this.handleChange("startDate", data.value)}
            />
            { errors.startDate && <Label basic pointing color='red'>{errors.startDate}</Label>}
          </Form.Field>}

          

        {!request.id && 
        <Form.Group>
          <Form.Field>
            <Checkbox label='Quantidade de Dias' onChange={() => this.setState({ showRepeat:!showRepeat })} />
          </Form.Field>
          {showRepeat && <Form.Field>
            <Input label='Dias' labelPosition='right' size='mini' value={request.repeats} name='repeats' type='number' min='0' max={maxRepeats} onChange={(e, data) => this.handleChange("repeats", data.value)} />
          </Form.Field>}
        </Form.Group>}

        {me && me.Role == userConstants.ROLE_USER && settings && settings.AllowChooseApprovers && <Form.Field required>
          <label>Aprovadores</label>
          <Dropdown
            placeholder='Digite nome, usuário ou e-mail'
            fluid            
            multiple
            selection                        
            onChange={(e, data) => this.handleChange("approvers", data.value)}
            onSearchChange={(e, data) => this.handleUserSearchChange(data.searchQuery)}                        
            search={(opt, qry) => this.simpleSearch(opt, qry)}            
            options={approverOptions}
          />            
          { errors.approvers && <Label basic pointing  color='red'>{errors.approvers}</Label>}          
        </Form.Field>}

        {me && me.Role != userConstants.ROLE_USER && me.Role != userConstants.ROLE_USER_MANAGER && !request.id &&
        <Form.Field required>
          <label>Usuários</label>
          <Dropdown
            placeholder='Digite nome, usuário ou e-mail'
            fluid            
            multiple
            selection            
            loading={usersLoading}
            onChange={(e, data) => this.handleUserChange(data)}
            onSearchChange={(e, data) => this.handleUserSearchChange(data.searchQuery)}                        
            search={(opt, qry) => this.simpleSearch(opt, qry)}
            value={request.requesterId} 
            options={userOptions}
          />            
          { errors.requesterId && <Label basic pointing  color='red'>{errors.requesterId}</Label>}          
        </Form.Field>
        }

        <Button type='submit' primary>Enviar Solicitação</Button>       
      </Form>
    </Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { users, requests, settings } = state;  
  
  let props = {
    me: users.me || null,
    subordinates: users.subordinates || null,
    usersLoading: users.loading,    
    settings: settings.globalSettings,
    loading: requests.loading,
    typeOptions: null,
  };

  if (requests && requests.item) {
    props.request = requests.item;      
  }
  
  if (props.settings && props.settings.AllowedRequestTypes) {
    const types = props.settings.AllowedRequestTypes.split(',');       
    const typeOptions = [];     
    if (types.includes(requestConstants.TYPE_ADDITIONAL.toString())) {
      typeOptions.push({ key: requestConstants.TYPE_ADDITIONAL, value: requestConstants.TYPE_ADDITIONAL, text: 'Tempo Adicional' });
    }
    if (types.includes(requestConstants.TYPE_SCHEDULED.toString()) || types.length === 0) {
      typeOptions.push({ key: requestConstants.TYPE_SCHEDULED, value: requestConstants.TYPE_SCHEDULED, text: 'Horário Agendado' });
    }
    if (types.includes(requestConstants.TYPE_FULLDAY.toString())) {
      typeOptions.push({ key: requestConstants.TYPE_FULLDAY, value: requestConstants.TYPE_FULLDAY, text: 'Dia Inteiro' });
    }        
    if (types.includes(requestConstants.TYPE_START.toString())) {
      typeOptions.push({ key: requestConstants.TYPE_START, value: requestConstants.TYPE_START, text: 'Início de Jornada Antecipada' });
    }        
    if (types.includes(requestConstants.TYPE_UNLOCK.toString())) {
      typeOptions.push({ key: requestConstants.TYPE_UNLOCK, value: requestConstants.TYPE_UNLOCK, text: 'Início de Jornada' });
    }        
    
    props.typeOptions = typeOptions;
  }

  return props;
}

const connectedRequestFormScreen = connect(mapStateToProps)(RequestFormScreen);
export { connectedRequestFormScreen as RequestFormScreen };
